import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.palette.background};
  border: 1px solid ${({ theme }) => theme.palette.common.PRIMARY};
  border-radius: 8px;
  padding: 24px;
  flex: 1 0 0;
  min-width: 320px;
`;

export const Head = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
`;

export const Foot = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  flex: 1 0 0;
`;

export const Title = styled.p`
  font-size: 20px;
  line-height: 32px;
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-weight: 700;
  margin: 0 0 16px;
`;

export const Text = styled.p<{ $bolder?: boolean }>`
  margin: 0;
  font-size: 16px;
  line-height: normal;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: ${({ $bolder }) => ($bolder ? 500 : 400)};
`;

export const Rating = styled.div`
  display: flex;
  gap: 8px;
`;
